// Ícones próprios, traço simples (viewBox 24, pontas redondas). Sempre decorativos (aria-hidden): o nome acessível fica no botão.
// `vb` recorta a caixa quando o glifo tem de encher o espaço (facetas da busca).
const S = (d: string, w = 1.75, vb = "0 0 24 24") => () => (
  <svg viewBox={vb} fill="none" stroke="currentColor" stroke-width={w} stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d={d} />
  </svg>
);
export const IconPlus = S("M12 5v14M5 12h14", 2);
export const IconClose = S("M6 6l12 12M18 6L6 18", 2);
export const IconAlert = S("M12 8v5M12 16.5v.5M10.3 3.9L2.5 18a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z");
export const IconSpin = () => (
  <svg class="spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true">
    <path d="M12 3a9 9 0 1 1-9 9" />
  </svg>
);
export const IconUp = S("M12 19V5M6 11l6-6 6 6");
export const IconCheck = S("M5 12.5l4.5 4.5L19 7.5", 2);
export const IconOffline = S("M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM5.6 5.6l12.8 12.8");
export const IconPrev = S("M15 6l-6 6 6 6", 2);
export const IconChevronUp = S("M6 16l6-7 6 7", 2); // 14 × 9 numa caixa de 24 (Voltar ao topo)
export const IconKeyboard = S("M3 6.5h18v11H3zM7 10h.01M10.5 10h.01M14 10h.01M17.5 10h.01M8 14h8");
export const IconTrash = S("M3 6.5h18M9 6.5V3h6v3.5M5.5 6.5l1 14.5h11l1-14.5M10 10.5v6.5M14 10.5v6.5");
export const IconGrid2 = S("M4.5 4.5h6v6h-6zM13.5 4.5h6v6h-6zM4.5 13.5h6v6h-6zM13.5 13.5h6v6h-6z");
export const IconGrid3 = S("M4 4h4v4H4zM10 4h4v4h-4zM16 4h4v4h-4zM4 10h4v4H4zM10 10h4v4h-4zM16 10h4v4h-4zM4 16h4v4H4zM10 16h4v4h-4zM16 16h4v4h-4z", 1.5);
export const IconGrid4 = S(
  "M4 4h2.5v2.5H4zM8.5 4H11v2.5H8.5zM13 4h2.5v2.5H13zM17.5 4H20v2.5h-2.5zM4 8.5h2.5V11H4zM8.5 8.5H11V11H8.5zM13 8.5h2.5V11H13zM17.5 8.5H20V11h-2.5zM4 13h2.5v2.5H4zM8.5 13H11v2.5H8.5zM13 13h2.5v2.5H13zM17.5 13H20v2.5h-2.5zM4 17.5h2.5V20H4zM8.5 17.5H11V20H8.5zM13 17.5h2.5V20H13zM17.5 17.5H20V20h-2.5z",
  1.25,
);
export const IconGear = S(
  "M18.76 9.53L21.36 10.39L21.36 13.61L18.76 14.47L18.53 15.04L19.76 17.48L17.48 19.76L15.04 18.53L14.47 18.76L13.61 21.36L10.39 21.36L9.53 18.76L8.96 18.53L6.52 19.76L4.24 17.48L5.47 15.04L5.24 14.47L2.64 13.61L2.64 10.39L5.24 9.53L5.47 8.96L4.24 6.52L6.52 4.24L8.96 5.47L9.53 5.24L10.39 2.64L13.61 2.64L14.47 5.24L15.04 5.47L17.48 4.24L19.76 6.52L18.53 8.96ZM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z",
  1.5,
);
export const IconDownload = S("M12 4v11M7 10l5 5 5-5M5 20h14");
export const IconExternal = S("M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5");
export const IconCopy = S("M9 9h11v11H9zM15 9V4H4v11h5");
export const IconRing = S("M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16z");
export const IconRestore = S("M4.5 12a7.5 7.5 0 1 0 2.2-5.3L4 9.4M4 4.5v4.9h4.9");
export const IconSimilar = S("M4 20A16 16 0 0 1 20 4M8 20A12 12 0 0 1 20 8M12 20a8 8 0 0 1 8-8");
export const IconLink = S("M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1", 1.75, "2.75 2.75 18.5 18.5");
export const IconNote = S("M6 3h9l4 4v14H6zM9 11h7M9 15h7M9 7h3", 1.75, "2.5 2 20 20");
export const IconImage = S("M4 5h16v14H4zM4 16l5-5 4 4 2.5-2.5L20 17M15.5 9h.01", 1.75, "3 3 18 18");
export const IconSwatch = S("M12 3.5c3.2 3.6 6 6.9 6 10.3a6 6 0 0 1-12 0c0-3.4 2.8-6.7 6-10.3z"); // gota de tinta (cor e paleta)
export const IconQuote = S("M10 7.5C7 8.3 5.5 10.6 5.5 14v2.5h4.5V12H7.6c.2-1.5 1.1-2.5 2.4-3M18.5 7.5c-3 .8-4.5 3.1-4.5 6.5v2.5h4.5V12h-2.4c.2-1.5 1.1-2.5 2.4-3"); // aspas (citação)
export const IconMasonry = S("M4 4h7v16H4zM13 4h7v7h-7zM13 13h7v7h-7z");
export const IconCompass = S("M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zM15.5 8.5l-2 5-5 2 2-5z");
export const IconMenu = S("M1.25 4.75h21.5M1.25 12h21.5M1.25 19.25h21.5", 2.5); // 24 × 17 (barra do celular)
export const IconCursorCard = S("M4 4h13v7M4 4v13h7M13 13l7 2.8-3 1.2-1.2 3z");
export const IconSearch = S("M10.5 4a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13zM15.3 15.3L20 20");
export const IconChevronDown = S("M6 9l6 6 6-6", 2);
export const IconLogout = S("M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4M10 8l-4 4 4 4M6 12h10");
/** Trilho: sol e lua cheios (o sol vai a 23 de 24 com os raios), grade 3 × 3 de quadrados sólidos. */
export const IconSun = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
    <circle cx="12" cy="12" r="5.25" stroke="none" />
    <path fill="none" d="M12 1.5v2M12 20.5v2M1.5 12h2M20.5 12h2M4.6 4.6L6 6M18 18l1.4 1.4M4.6 19.4L6 18M18 6l1.4-1.4" />
  </svg>
);
export const IconMoon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M21.44 13.04A9.5 9.5 0 1 1 10.96 2.56A7.5 7.5 0 0 0 21.44 13.04z" />
  </svg>
);
const CELLS = [2, 9.2, 16.4];
export const IconGridSolid = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    {CELLS.flatMap((y) => CELLS.map((x) => <rect key={`${x} ${y}`} x={x} y={y} width="5.6" height="5.6" rx="1.2" />))}
  </svg>
);
/** Sinal do wordmark no trilho: anel com um ponto de pelagem. */
export const Mark = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9.5" stroke="currentColor" stroke-width="1.75" />
    <circle cx="12" cy="12" r="3.25" fill="var(--accent)" />
  </svg>
);
